import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { StyledRadioGroup, StyledRadio } from "./radioGroupComponent.style";

export interface IRadioGroupComponentProps {
  data: {
    name: string;
    value: string;
  }[];
  selected: string;
  onChange: (e: any) => void;
  isRow: boolean;
  name: string;
  isPCL?: boolean;
  id?: string;
  sx?: any;
  disabled?: boolean;
}


const RadioGroupComponent: React.FC<IRadioGroupComponentProps> = (props) => {
  const { data, selected, onChange, isRow, name, isPCL = false, id, sx, disabled } = props;
  return (
      <StyledRadioGroup
        row={isRow}
        name={name}
        value={selected}
        onChange={onChange}
        id={id || `rad-${!!isPCL ? 'pcl' : 'radiogroupcomponent'}-radio_group`}
        sx={sx}
      >
        {data.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item.value}
            control={<StyledRadio isrow={+isRow} className="radio-node" disabled={disabled} />}
            label={item.name}
          />
        ))}
      </StyledRadioGroup>
  );
}

export const defaultProps = {
  data: [
    { value: "relevancy,true", name: "Relevance" },
    { value: "sys_view_count,true", name: "Views" },
  ],
  selected: "relevancy,true",
  isRow: false,
  onChange: () => { },
  name: "radioGroup"
};

RadioGroupComponent.defaultProps = defaultProps;

export default RadioGroupComponent;
